// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"87485b7e","120":"c243748f","150":"1f400b42","284":"9146f412","316":"b617161f","403":"03b8d716","573":"a401a63a","787":"0a92daf0","793":"8f0aa997","858":"ced03586","924":"ca5839a7"}[chunkId] + ".chunk.js";
};